export default function setBranch(branchId) {
	return {
		action : 'gumnut_set_branch',
		branchId: branchId
	}
}
